<div class="pv" #container
    [class.pv-tocando]="tocando()" [class.pv-controles-ocultos]="!controlesVisiveis()" [class.pv-tela-cheia]="telaCheia()"
    (pointermove)="aoMoverPonteiro($event)" (pointerleave)="aoSairPlayer()">
  <video #video class="pv-video" autoplay playsinline preload="metadata" [src]="src"
        (pointerdown)="aoPressionarVideo($event)" (click)="aoClicarVideo($event)" (dblclick)="alternarTelaCheia($event)"
        (play)="aoTocar()" (pause)="aoPausar()" (ended)="aoTerminar()"
        (loadedmetadata)="aoCarregarMetadados()" (durationchange)="aoMudarDuracao()"
        (timeupdate)="aoAtualizarTempo()" (progress)="aoProgredir()"
        (waiting)="carregando.set(true)" (canplay)="carregando.set(false)" (playing)="carregando.set(false)"
        (error)="aoFalhar()"></video>

  @if (erro()) {
    <div class="pv-erro">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 5h13v14H3zM16 10l5-3v10l-5-3z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M2 3l20 18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>
      <span class="pv-erro-titulo">Vídeo indisponível</span>
      <span class="pv-erro-texto">O arquivo não está mais disponível ou não pôde ser carregado.</span>
    </div>
  } @else {
    <div class="pv-carregando" [class.pv-carregando-visivel]="carregando() && tocando()" aria-hidden="true">
      <span class="pv-spinner"></span>
    </div>

    <div class="pv-topo" role="presentation" (pointerdown)="$event.stopPropagation()" (click)="$event.stopPropagation()"
         (pointerenter)="aoEntrarControles()" (pointerleave)="aoSairControles()">
      <button type="button" class="pv-btn" [attr.aria-label]="telaCheia() ? 'Sair da tela cheia' : 'Tela cheia'" (click)="alternarTelaCheia($event)">
        @if (telaCheia()) {
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square"/></svg>
        } @else {
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square"/></svg>
        }
      </button>
      @if (suportaPip) {
        <button type="button" class="pv-btn" [attr.aria-label]="emPip() ? 'Voltar do picture-in-picture' : 'Picture-in-picture'" (click)="alternarPip($event)">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M11 4H4v16h16v-7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square"/><path d="M14 4h6v6M20 4l-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square"/></svg>
        </button>
      }
    </div>

    <div class="pv-controles" role="presentation" (pointerdown)="$event.stopPropagation()" (click)="$event.stopPropagation()"
         (pointerenter)="aoEntrarControles()" (pointerleave)="aoSairControles()">
      <button type="button" class="pv-btn" [attr.aria-label]="tocando() ? 'Pausar' : 'Tocar'" (click)="alternar($event)">
        <span class="pv-icone-troca" [class.pv-icone-troca-ligado]="tocando()">
          <svg class="pv-icone-a" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 4l14 8-14 8z" fill="currentColor"/></svg>
          <svg class="pv-icone-b" viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="4" width="4" height="16" fill="currentColor"/><rect x="14" y="4" width="4" height="16" fill="currentColor"/></svg>
        </span>
      </button>

      <div class="pv-barra" [class.pv-barra-arrastando]="arrastando()" role="slider" tabindex="0" aria-label="Posição do vídeo"
          [attr.aria-valuenow]="atual()" [attr.aria-valuemin]="0" [attr.aria-valuemax]="duracao()"
          [attr.aria-valuetext]="formatar(atual())"
          (pointerdown)="aoPressionarBarra($event)" (pointermove)="aoMoverBarra($event)"
          (pointerup)="aoSoltarBarra($event)" (pointercancel)="arrastando.set(false)"
          (pointerleave)="posicaoHover.set(null)" (keydown)="aoTeclarBarra($event)">
        <span class="pv-barra-trilho">
          <span class="pv-barra-carregado" [style.transform]="'scaleX(' + progressoCarregado() + ')'"></span>
          <span class="pv-barra-progresso" [style.transform]="'scaleX(' + progresso() + ')'"></span>
        </span>
        <span class="pv-barra-marcador" [style.left.%]="progresso() * 100"></span>
        @if (posicaoHover(); as hover) {
          <span class="pv-barra-dica" [style.left.%]="hover * 100">{{ formatar(hover * duracao()) }}</span>
        }
      </div>

      <button type="button" class="pv-velocidade" aria-label="Velocidade do vídeo" (click)="trocarVelocidade($event)">{{ rotuloVelocidade() }}</button>

      <div class="pv-som">
        <input type="range" class="pv-volume" min="0" max="1" step="0.05" aria-label="Volume"
              [value]="volumeExibido()" [style.--volume]="volumeExibido()" (input)="aoMudarVolume($event)" />
        <button type="button" class="pv-btn" [attr.aria-label]="mudo() ? 'Ativar som' : 'Tirar som'" (click)="alternarSom($event)">
          @if (volumeExibido() === 0) {
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 9h4l5-4v14l-5-4H3z" fill="currentColor"/><path d="M16 9l5 6M21 9l-5 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
          } @else {
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 9h4l5-4v14l-5-4H3z" fill="currentColor"/><path d="M15.5 9a4 4 0 010 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M18.5 6a8 8 0 010 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" [attr.opacity]="volumeExibido() > 0.5 ? 1 : 0.35"/></svg>
          }
        </button>
      </div>
    </div>
  }
</div>
